<template>
  <div class="free-table" :class="optimize ? 'optimize' : ''">
    <el-table ref="elTable" :data="data" v-bind="$attrs" v-on="$listeners" :max-height="maxTableHeight"
      :header-cell-style="styleObj">
      <template v-for="item in tbColumns">
        <el-table-column show-overflow-tooltip v-if="item.slotScope" v-bind="item" :key="item.prop" v-on="$listeners">
          <template slot-scope="scope">
            <slot :name="item.prop" v-bind="scope"></slot>
          </template>
        </el-table-column>

        <free-column v-else v-bind="$attrs" :key="item.prop" :column="item" />
      </template>
      <template slot="empty"
        v-if="showCompanyBtn && $store.state.userPlatForm === 'platForm' && defaultIdType === 'hospitalId'">
        <!-- 机构 ---- 边链中患者链才加，其他保持不变 -->
        <div>
          <div>对应机构暂无数据，是否去平台查找</div>
          <el-button type="primary" @click="companySearch">搜平台</el-button>
        </div>
      </template>
    </el-table>
    <template slot="empty" v-if="defaultIdType === 'companyId' && !data.length">
      <!-- 平台搜索过后也无数据的情况下展示 -->
      <div>
        <div>暂无数据</div>
      </div>
    </template>
    <template v-if="pagination">
      <pagination v-if="data.length > 0" v-bind="$attrs" v-on="$listeners" />
    </template>
  </div>
</template>

<script>
import FreeColumn from './columu'
import Pagination from '../Pagination'
import { EnumUtils } from "@/enums/enumUtils";

export default {
  name: 'FreeTable',
  components: {
    Pagination,
    FreeColumn
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    optimize: {
      type: Boolean,
      default: false
    },
    column: {
      type: Array,
      defalut: () => []
    },
    columnsProps: Object,
    //  columnsProps: {
    //   type: Object,
    //   default: ()=>Object
    // },
    pagination: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: '100px'
    },
    styleObj: {
      type: Object,
      default() {
        return {
          background: '#FAFAFA',
          fontWeight: 'bold',
          color: '#333333',
          fontSize: '14px'
        }
      }
    },
    // 是否展示搜平台按钮
    showCompanyBtn: {
      type: Boolean,
      default: false
    },
    // 当前搜索数据是平台还是机构
    defaultIdType: {
      type: String,
      default: 'hospitalId'
    }
  },
  data() {
    return {
      maxTableHeight: 'auto'
    }
  },
  watch: {
    maxHeight(val) {
      this.maxTableHeight = val
    }
  },
  computed: {
    tbColumns() {
      const { column, columnsProps: props } = this

      return column.map(col => {

        const it = Object.assign({}, props, col);
        if (col.enumType) {
          it.render = (h, scope) => {
            return (
              <span>{EnumUtils.getEnumDisplay(col.enumType, scope.row[col.prop])}</span>
            );
          }
        }
        return it;
      })
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (!rowIndex) {
        return 'warning-row';
      }
    },
    // 搜平台
    companySearch() {
      this.$emit('companySearch')
    }
  }
}
</script>
<style lang="less">
// .el-table .warning-row {
//     background: oldlace;FreeTable/BaseTable
//   }
.el-tooltip__popper {
  font-size: 12px;
  max-width: 300px;
}

// .optimize{
//   border: solid 1px red;
// }
</style>
